import React, { useState, useEffect } from 'react';
import { FaGooglePlay } from 'react-icons/fa';
import { FaApple } from 'react-icons/fa6';
import Group from '../images/Group.png';
import Hm1 from '../images/hm1.jpeg';
import Hm2 from '../images/hm2.jpeg';
import Hm3 from '../images/hm3.jpeg';
import Hm4 from '../images/hm4.jpeg';
import Hm5 from '../images/hm5.jpeg';

const Home = () => {

	return (
		<div className='lg:mt-[50px] w-full lg:flex flex-col'>
			<div className='lg:w-[819px] w-full items-center justify-center mx-auto text-center'>
				<h1
					className='lg:text-[54px] text-[30px] text-center font-bold pt-[52px] lg:pt-0'
					style={{ fontFamily: 'EinaBold' }}
				>
					HUMANITY NEST FOUNDATION
					<span className='text-[#4aa39c]'> Inspiring hope..... Nurturing a global Humanity.</span>
				</h1>
				<h1
					className='leading-6 mt-[28px] text-[16px] text-center font-normal lg:w-[589px] mx-auto text-[#301F1ECC]'
					style={{ fontFamily: 'EinaRegular' }}
				>
					Empowering communities across  Africa  through  Human capacity development, food, micro SME grants education, health,   and women’s support
				</h1>
				<div className='mt-[87px] bg-white w-full'>
					<iframe height="400" className='w-full' src="https://www.youtube.com/embed/pLeJII6hOBk?si=63e3yFax2GdscJwc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
				</div>

			</div>

			<div className='mt-[58px] lg:w-[509px] mx-auto text-center'>
				<p
					style={{ fontFamily: 'EinaBold' }}
					className='text-[28px] lg:text-[36px]'
				>
					About Us
				</p>
				<p
					className='text-[#000000B2] text-[14px] lg:text-[16px]'
					style={{ fontFamily: 'EinaO1Regular' }}
				>
					Humanity Nest, is a Transparent Continuous Recurring aid distribution channel for the needy, we connect those in need of basic necessities to kind hearted Donors through our 53 COMMUNITY MINI DONATION/FOOD PANTRY CENTERS .
					Through our Active 52 Community mini donation cross Africa, we’ve impacted over 50,000 lives — and counting.

				</p>
			</div>
			<div className='flex flex-col my-[36px] gap-[22px]'>
				<div>
					<p
						style={{ fontFamily: 'EinaBold' }}
						className='text-[28px] lg:text-[36px]'
					>
						Educational Aid
					</p>
					<p className='text-[#000000B2] text-[14px] lg:text-[16px]'
						style={{ fontFamily: 'EinaO1Regular' }}>
						Distributing learning materials, school packs, and sponsoring educational initiatives
					</p>
					<img src={Hm1} className='w-full' />
				</div>
			</div>
			<div className='flex flex-col my-[36px] gap-[22px]'>
				<div>
					<p
						style={{ fontFamily: 'EinaBold' }}
						className='text-[28px] lg:text-[36px]'
					>
						Human capacity development
					</p>
					<p className='text-[#000000B2] text-[14px] lg:text-[16px]'
						style={{ fontFamily: 'EinaO1Regular' }}>
						We provide skills and training.
					</p>
					<img src={Hm2} className='w-full' />
				</div>
			</div>
			<div className='flex flex-col my-[36px] gap-[22px]'>
				<div>
					<p
						style={{ fontFamily: 'EinaBold' }}
						className='text-[28px] lg:text-[36px]'
					>
						Food & Gently Used Items
					</p>
					<p className='text-[#000000B2] text-[14px] lg:text-[16px]'
						style={{ fontFamily: 'EinaO1Regular' }}>
						Supplying Food  and distributing gently used clothing and household essentials to those in need.
					</p>
					<img src={Hm3} className='w-full' />
				</div>
			</div>
			<div className='flex flex-col my-[36px] gap-[22px]'>
				<div>
					<p
						style={{ fontFamily: 'EinaBold' }}
						className='text-[28px] lg:text-[36px]'
					>
						Health Screening & Aid
					</p>
					<p className='text-[#000000B2] text-[14px] lg:text-[16px]'
						style={{ fontFamily: 'EinaO1Regular' }}>
						Organizing free health checks and providing essential medical support to underserved communities.
					</p>
					<img src={Hm4} className='w-full' />
				</div>
			</div>
			<div className='flex flex-col my-[36px] gap-[22px]'>
				<div>
					<p
						style={{ fontFamily: 'EinaBold' }}
						className='text-[28px] lg:text-[36px]'
					>
						SHE Impact
					</p>
					<p className='text-[#000000B2] text-[14px] lg:text-[16px]'
						style={{ fontFamily: 'EinaO1Regular' }}>
						Providing support, self-care kits, and educational materials for girls and women.

						Empowering women to thrive with dignity and confidence.
					</p>
					<img src={Hm5} className='w-full' />
				</div>
			</div>
			<div className='flex flex-col my-[36px] gap-[22px]'>
				<div>
					<p
						style={{ fontFamily: 'EinaBold' }}
						className='text-[28px] lg:text-[36px]'
					>
						How You Can Give/
						Donate Through Our Community Network
					</p>
					<p className='text-[#000000B2] text-[14px] lg:text-[16px]'
						style={{ fontFamily: 'EinaO1Regular' }}>
						Visit any Mini Donation & Food Pantry Center across Nigeria and Cameroon.

					</p>
					<p className='text-[#000000B2] text-[14px] lg:text-[16px]'
						style={{ fontFamily: 'EinaO1Regular' }}>
						Contribute materials, food, or financial donations.
					</p>
					<p className='text-[#000000B2] text-[14px] lg:text-[16px]'
						style={{ fontFamily: 'EinaO1Regular' }}>
						Your generosity fuels our mission and brings hope to thousands.
					</p>
					<p
						style={{ fontFamily: 'EinaBold' }}
						className='text-[18px] lg:text-[20px] mt-[20px]'
					>
						Dollar Account ( USD)</p>
					<div>
						<span>Account Number:</span><span>5074600217.</span>
					</div>
					<div>
						<span>ACC Name:</span><span>Humanity Nest Foundation.</span>
					</div>
					<div>
						<span>Zenith bank</span>
					</div>

					<p
						style={{ fontFamily: 'EinaBold' }}
						className='text-[18px] lg:text-[20px] mt-[20px]'
					>
						Naira Account ( NGN)</p>
					<div>
						<span>Account Number:</span><span>1229940542.</span>
					</div>
					<div>
						<span>ACC Name:</span><span>Humanity Nest Foundation.</span>
					</div>
					<div>
						<span>Zenith bank</span>
					</div>

				</div>
			</div>
			<div className='flex flex-col gap-[22px]'>
				<div>
					<p
						style={{ fontFamily: 'EinaBold' }}
						className='text-[28px] lg:text-[36px]'
					>
						Impact in Numbers

					</p>
					<div className='text-[#000000B2] text-[14px] lg:text-[16px]'
						style={{ fontFamily: 'EinaO1Regular' }} >
						<p>	Visit any Mini Donation & Food Pantry Center across Nigeria and Cameroon.</p>
						<p>Over <b className='text-[#4aa39c] text-xl'>100,000 </b>lives impacted
							🌍 Serving communities in Nigeria & Cameroon
							🤝 Transparent continuous recurring aid distribution through community-based centers
						</p>
						<h1>Get Involved</h1>
						<p>Donate Now – Give food, materials, or funds</p>
						<p>Volunteer – Join our growing network of changemakers.
						</p>
						<p>Partner – Work with us to reach more communities. Donate to humanity Nest
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Home;
